import React, { useState, useRef, useEffect, Fragment } from "react";
import { useSelector, useDispatch } from "react-redux";
import ReactHTMLTableToExcel from "react-html-table-to-excel";

import {
  getAllDesignation,
  getAllDepartment,
  addDepartmentOrDesignation
} from "../../../redux/actions/hrActions";
import Card from "../../../component/card/Card";
import DepartmentList from "./DepartmentList";
import DesignationList from "./DesignationList";
import TextInput from "../../../component/input/TextInput";
import Button from "../../../component/button/Button";
import { helperFunction } from "../../../constant/helper";
import Starter from "../../../component/Starter";

const AllOthers = () => {
  const dispatch = useDispatch();
  const departmentRef = useRef();
  const designationRef = useRef();

  const loginType = localStorage.loginType;

  const [department, setDepartment] = useState([]);
  const [designation, setDesignation] = useState([]);
  const [newDesignation, setNewDesignation] = useState("");
  const [newDepartment, setNewDepartment] = useState("");

  const { allDesignations, allDepartments, hrError, hrResponse } =
    useSelector((state) => state.hr);

  useEffect(() => {
    setTimeout(() => {
      if (allDesignations.length === 0) {
        dispatch(getAllDesignation(loginType));
      }
      if (allDepartments.length === 0) {
        dispatch(getAllDepartment(loginType));
      }
    }, 1000);
  }, []);

  useEffect(() => {
    if (allDepartments !== null) {
      setDepartment(allDepartments);
    } else {
      setDepartment([]);
    }
  }, [allDepartments]);

  useEffect(() => {
    if (allDesignations !== null) {
      setDesignation(allDesignations);
    } else {
      setDesignation([]);
    }
  }, [allDesignations]);

  useEffect(() => {
    if (hrError) {
      helperFunction.toastHelper("error", hrError);
    }
    if (hrResponse) {
      helperFunction.toastHelper("success", hrResponse);
    }
  }, [hrError, hrResponse]);

  const onSubmit = (e, type) => {
    e.preventDefault();
    let constantData;
    if (type === "designation") {
      constantData = {
        data: newDesignation,
        type
      };
    } else {
      constantData = {
        data: newDepartment,
        type
      };
    }
    dispatch(addDepartmentOrDesignation(constantData, loginType));
  };

  return (
    <Starter
      topBarTitle="All Department / Designation"
      breadCrumb={
        <Fragment>
          <li className="breadcrumb-item">
            <a href="#">HR Module</a>
          </li>
          <li className="breadcrumb-item">
            <a href="#">HR</a>
          </li>
          <li className="breadcrumb-item active">
            All Department / Designation
          </li>
        </Fragment>
      }
    >
      <ReactHTMLTableToExcel
        data-tip
        sheet="Sheet"
        filename="Department"
        className="btn btn-warning mb-2 mr-2"
        data-for="exportToExcel"
        buttonText="Export Department"
        table="department-datatable"
      />
      <ReactHTMLTableToExcel
        data-tip
        sheet="Sheet"
        filename="Designation"
        className="btn btn-secondary mb-2 mr-2"
        data-for="exportToExcel"
        buttonText="Export Designation"
        table="designation-datatable"
      />

      <div className="row">
        <div className="col-xl-6 col-lg-6 col-md-6">
          <Card>
            <div
              className="row"
              style={{ height: "500px", overflow: "auto" }}
            >
              <div className="col-xl-6 col-lg-6 col-md-6">
                <div
                  className="table-responsive"
                  ref={designationRef}
                >
                  <table
                    className="table table-bordered table-centered mb-0 table-hover w-100 dt-responsive nowrap"
                    id="department-datatable"
                  >
                    <thead className="thead-light">
                      <tr>
                        <th style={{ width: "20px" }}>#</th>
                        <th>DEPARTMENT NAME</th>
                      </tr>
                    </thead>
                    <tbody>
                      <DepartmentList departmentList={department} />
                    </tbody>
                  </table>
                </div>
              </div>
              <div className="col-xl-6 col-lg-6 col-md-6">
                <form onSubmit={(e) => onSubmit(e, "department")}>
                  <TextInput
                    type="text"
                    required={true}
                    textWhite={false}
                    htmlFor="department"
                    value={newDepartment}
                    label="Add Department"
                    placeholder="Add New Department"
                    onChange={(e) => setNewDepartment(e.target.value)}
                  />
                  <div className="form-group mb-0 text-center mt-3">
                    <Button
                      type="submit"
                      title="Submit"
                      icon="mdi mdi-login"
                      isBackgroundColor={false}
                      className="btn mb-2 text-white btn-dark btn-sm"
                    />
                  </div>
                </form>
              </div>
            </div>
          </Card>
        </div>

        <div className="col-xl-6 col-lg-6 col-md-6">
          <Card>
            <div
              className="row"
              style={{ height: "500px", overflow: "auto" }}
            >
              <div className="col-xl-6 col-lg-6 col-md-6">
                <div className="table-responsive" ref={departmentRef}>
                  <table
                    className="table table-bordered table-centered mb-0 table-hover w-100 dt-responsive nowrap"
                    id="designation-datatable"
                  >
                    <thead className="thead-light">
                      <tr>
                        <th style={{ width: "20px" }}>#</th>
                        <th>DESIGNATION NAME</th>
                      </tr>
                    </thead>
                    <tbody>
                      <DesignationList
                        designationList={designation}
                      />
                    </tbody>
                  </table>
                </div>
              </div>
              <div className="col-xl-6 col-lg-6 col-md-6">
                <form onSubmit={(e) => onSubmit(e, "designation")}>
                  <TextInput
                    type="text"
                    required={true}
                    textWhite={false}
                    htmlFor="designation"
                    value={newDesignation}
                    label="Add Designation"
                    placeholder="Add New Designation"
                    onChange={(e) =>
                      setNewDesignation(e.target.value)
                    }
                  />
                  <div className="form-group mb-0 text-center mt-3">
                    <Button
                      type="submit"
                      title="Submit"
                      icon="mdi mdi-login"
                      isBackgroundColor={false}
                      className="btn mb-2 text-white btn-dark btn-sm"
                    />
                  </div>
                </form>
              </div>
            </div>
          </Card>
        </div>
      </div>
    </Starter>
  );
};

export default AllOthers;
